{
  "version": 1,
  "asset_id": "4f69377a-02ec-45f4-be6f-4c97b9141fd8",
  "project_id": "08095a77-1ee2-43eb-a056-e04547e15531",
  "url": "/__l5e/assets-v1/4f69377a-02ec-45f4-be6f-4c97b9141fd8/gps-drive-logo-v3.png",
  "r2_key": "a/v1/08095a77-1ee2-43eb-a056-e04547e15531/4f69377a-02ec-45f4-be6f-4c97b9141fd8/gps-drive-logo-v3.png",
  "original_filename": "gps-drive-logo-v3.png",
  "size": 164027,
  "content_type": "image/png",
  "created_at": "2026-07-10T14:21:57Z"
}
